<template>
  <div class="list-attributes d-md-inline-flex">
    <div class="attribute" v-for="(item, index) in items" :key="index">
      <div class="field">{{ item.key }}</div>
      <div
        class="value"
        :style="`word-break: ${item.wordBreak}`"
        :class="`text-${item.variant}`"
        v-html="item.value"
      ></div>
      <div v-if="item.canCopy" class="ml-1">
        <CopyToClipboard :text="item.value.toString()" />
      </div>
    </div>
  </div>
</template>

<script>
import CopyToClipboard from "@/components/display/CopyToClipboard";
export default {
  name: "HorizontalList",
  components: { CopyToClipboard },
  props: {
    items: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.list-attributes {
  font-size: 0.875rem;
  .attribute {
    display: flex;
    align-items: baseline;
    @include media-breakpoint-up(md) {
      &:not(:last-child) {
        &::after {
          margin-right: 1rem;
          margin-left: 1rem;
          content: "|";
        }
      }
    }
    .field {
      font-size: 0.75rem;
      margin-right: 0.5rem;
    }
    .value {
      font-weight: bold;
    }
  }
}
</style>
